var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6753 3.84127C12.138 3.58521 9.57747 3.45718 7.02857 3.45718C5.51552 3.45718 4.00248 3.53865 2.50107 3.68996L0.941467 3.84127",
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.14325 3.07316L5.30619 2.07222C5.42258 1.35061 5.51568 0.803589 6.80759 0.803589H8.80947C10.1014 0.803589 10.1945 1.37389 10.3109 2.07222L10.4738 3.06152",
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0341 3.93424L12.5336 11.6159C12.4522 12.8147 12.3823 13.7458 10.2524 13.7458H5.35248C3.22257 13.7458 3.15273 12.8147 3.07126 11.6159L2.5708 3.93424",
    stroke: "#9F9F9F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f4ec1e75ab11a01025ec98da55f4a847.svg";
export { ForwardRef as ReactComponent };